module.exports = __webpack_public_path__ + "static/media/features-split-image.ce83ce96.svg";